import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {InputText} from 'primereact/inputtext';
import {Dropdown} from 'primereact/dropdown';
import {MultiSelect} from 'primereact/multiselect';
import {Button} from 'primereact/button';
import {InputSwitch} from 'primereact/inputswitch';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { FieldValidations, FormSelections, HASACCESS } from '../../../shared/utility';
import axios from '../../../axios-url';
import {Toast} from 'primereact/toast';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import { PROCESS_SUBMENU_ID } from '../../../shared/Config';
class ProcessForm extends Component {
    state = {
        stages : [],
        selectOption : FormSelections,
        dataSourceOption : [
            {
                label: 'Select Drowdown API',
                value: 'null'
            },
            {
                label: 'Leave Type',
                value: 'Leave Type'
            },
            {
                label: 'Ticket Route',
                value: 'Ticket Route'
            },
            {
                label: 'Gender',
                value: 'Gender'
            },
        ],
        parentControlOption : [
            {
                label: 'Select Parent Control',
                value: 'null'
            }
        ],
        ValidationAPI : [
            {
                label: 'Select Validation API',
                value: 'null'
            },
        ],
        fieldStatusOption : [
            {
                label: 'Select Field Status',
                value: 'null'
            },
            {
                label: 'Display Only',
                value: 'Display Only'
            },
            {
                label: 'Editable',
                value: 'Editable'
            },
            {
                label: 'Required',
                value: 'Required'
            },
            {
                label: 'Optional',
                value: 'Optional'
            },
        ],

        defaultFields : {
            FieldDescription : '',
            FieldType : '',
            //dropdownValue: '',
            ParentFieldNum : '000',
            FieldStatus : '',
            FieldValidation : '',
            ValidationAPI : ''
            
        },
        processNum : 'Auto Generate',
        processDesc : '',
        MenuID: '',
        ModuleNum: null,
        loading : false,
        isActive : true,
        type : 'Add',
        processId : null,
        loadOnce : false,
        CreatedDate : new Date()
    }

    createStage = () => { 
        var Stage_Field = [this.state.defaultFields]  
        var newInput = [...this.state.stages, {"Description" : "","StageSequence" : "","AllowAutoApprove" : false ,"AllowAttachment" : false ,"AllowForms" : false, "AllowAction" : false  ,"AutoApproveDays" : ""  ,Stage_Field}];
        this.setState({
            stages: newInput
        });
    }

    removeStage = (e, removeIndex) => {
        const updatedStages= this.state.stages.filter((value,index) => {
           return removeIndex !== index;
        });
        this.setState({stages:updatedStages})
    }


    updateDynamicStageFields = (e, index) => { 
        const { name, value } = e.target;
        let stageValues  = [...this.state.stages];
        let  stageIndex= { 
            ...stageValues[index]
        };

        stageIndex[name]= value;
        stageValues[index] = stageIndex;

        this.setState({
            stages: stageValues
        });

    }

    updateDynamicFields = (e, index, btnIndex) => { 
        const { name, value } = e.target;
        let stageValues  = [...this.state.stages];
        let  stageIndex= [ 
            ...stageValues[index].Stage_Field
        ];

       let fieldsPlace = {
           ...stageIndex[btnIndex]
       }

      
        fieldsPlace[name] = value;
               
 
        stageIndex[btnIndex] = fieldsPlace;
     

        stageValues[index].Stage_Field = stageIndex;
        
        this.setState({
            stages: stageValues
        });

        if(name === 'FieldType' && value === 9 && fieldsPlace.FieldDescription !==''){

            var parentField =
                {
                    label : fieldsPlace.FieldDescription,
                    value : fieldsPlace.StageFieldNum ? fieldsPlace.StageFieldNum : fieldsPlace.FieldDescription
                }

            let alreadyAdded = this.state.parentControlOption.some(option => option.value === parentField.value);

            if(!alreadyAdded){
                var newInput = [...this.state.parentControlOption, parentField];

                this.setState({
                    parentControlOption: newInput
                });
            }
        }
    }

    addFields = (e, index, btnIndex) => {
        e.preventDefault();
        
        
        const stageValues  = [...this.state.stages];
        const stageIndex = [ 
            ...stageValues[index].Stage_Field
        ];


        let newDept = this.state.defaultFields
     
        stageIndex[stageIndex.length] = newDept;
        
  
        stageValues[index].Stage_Field =stageIndex;

        this.setState({stages:stageValues})
    }


    removeFields = (e, index, btnIndex) => {
        e.preventDefault();
     

        const stageValues  = [...this.state.stages];
        const stageFields = [ 
            ...stageValues[index].Stage_Field
        ];
        const updatedValue = stageFields.filter((field, i) => {
            return btnIndex !== i;
        });
        stageValues[index].Stage_Field =updatedValue;
        this.setState({stages:stageValues})
    }


    componentDidMount(){
        this.props.getModuleLists();
        this.getAccess = HASACCESS(PROCESS_SUBMENU_ID);

        if(this.props.match.params.processID !== undefined){
            this.setState({processId:this.props.match.params.processID,type:this.props.match.params.type});
            this.props.fetchProcessForm(this.props.match.params.processID);
        }

        setTimeout(() => {
            if(this.props.employeeID !== null){
                this.props.onMenuAccess(this.props.employeeID,'GetInitialAccess');
            }
        }, 2000);
       
    }

    componentDidUpdate(){
        

        if(this.props.loggedUserDetail.CompanyId === null){
            window.location.reload(false);
        }

        if(this.props.fetchData.processId !== undefined && this.state.loadOnce === false){
          
            let fetchData = this.props.fetchData;
            this.setState({
                loadOnce: true,
                processNum:fetchData.processNum,
                ModuleNum:fetchData.moduleNum,
                processId: fetchData.processId,
                processDesc: fetchData.processDesc,
                CreatedDate : fetchData.createdDate,
                isActive : fetchData.isActive,
                CompanyId: fetchData.companyId,
                CreatedBy: fetchData.createdBy,
                MenuID: fetchData.menuID,
                SubMenuID: fetchData.subMenuID
            });

            let parentFieldArray = [];
           
            if(fetchData.stage.length > 0){
                let Stage_Field = []; 

                let stage = fetchData.stage.map((st,index) => {

                    if(st.stage_Field.length > 0){

                        Stage_Field = st.stage_Field.map((field,stIndex) => {

                            let fieldValidation = '';
                            if(field.fieldValidation !==''){
                                fieldValidation = field.fieldValidation.split(',').map(Number);
                            }

                            if(field.fieldType === 9){

                                var obj = { label : field.fieldDescription,
                                            value : field.stageFieldNum
                                        };
                    
                                parentFieldArray.push(obj);


                              
                            }


                            return {
                                stageName : field.stageName, stageID: field.stageID, processName: field.processName,processID:field.processID,StageFieldID:field.stageFieldID,StageFieldNum:field.stageFieldNum,FieldDescription:field.fieldDescription,FieldType:field.fieldType,FieldSequence:field.fieldSequence,parentFieldType:field.parentFieldType,isActive:field.isActive,CreatedDate:field.createdDate,CreatedBy:field.createdBy,FieldStatus:field.fieldStatus,FieldValidation:fieldValidation,ValidationAPI:field.validationAPI,ParentFieldNum:field.parentFieldNum
                            }
                        });

                    }
                    return {
                        "stageID" : st.stageID,"Description" : st.description,"processID" : st.processID,"isActive": st.isActive,
                        ModuleNum:fetchData.ModuleNum, processNum:fetchData.processNum,CreatedBy : st.createdBy, CreatedDate:st.createdDate, "StageSequence" : st.stageSequence, "StageNum" : st.stageNum, "AllowAutoApprove" : st.allowAutoApprove ,"AllowAttachment" : st.allowAttachment ,"AllowForms" : st.allowForms, "AllowAction" : st.allowAction ,"AutoApproveDay" : st.autoApproveDay, Stage_Field
                    }
                })


                
                var newInput = [...this.state.stages, ...stage];
                this.setState({
                    stages: newInput,
                    parentControlOption: parentFieldArray
                });

            }
        }
    }
 
    
    addProcessForm = () => {


        if(this.state.processDesc === ''){
            this.growl.show({severity: 'error', summary: null, detail:'Process description is required'});
            return;
        }else if(this.state.ModuleNum === null){
            this.growl.show({severity: 'error', summary: null, detail:'Module name is required'});
            return;
        }
        else if(this.state.MenuID === ''){
            this.growl.show({severity: 'error', summary: null, detail:'Menu is required'});
            return;
        }

        
        this.setState({loading : true});
        let stages = this.state.stages.map( ( stage, index ) => {
            let Stage_Sequence = (stage.StageSequence !== '') ? stage.StageSequence : (index + 1);

            let Stage_Field = [];
            if(stage.Stage_Field.length > 0){
                Stage_Field = stage.Stage_Field.map( (field, index) => {
            
                    let fieldValid=''
                    if(field.FieldValidation !==null && field.FieldValidation.length > 0){
                         fieldValid = field.FieldValidation.join();  
                    }
                    
                    return { StageID: (stage.stageID!==undefined) ? stage.stageID : "", ProcessID :  this.state.processId, StageFieldID: (field.StageFieldID!==undefined) ? field.StageFieldID : "",FieldDescription:field.FieldDescription,FieldType:field.FieldType,FieldSequence : (index + 1),  IsActive : true,FieldStatus:field.FieldStatus,FieldValidation:fieldValid,ValidationAPI:field.ValidationAPI,ParentFieldNum:field.ParentFieldNum,CompanyId:this.props.loggedUserDetail.CompanyId}
                } )
            }

                           

            return { StageID: (stage.stageID!==undefined) ? stage.stageID : "", Description:stage.Description, ProcessID: this.state.processId ,IsActive: 1, ModuleNum :this.state.ModuleNum, StageSequence : Stage_Sequence, StageNum : (stage.StageNum!==undefined) ? stage.StageNum : null, AllowAutoApprove:stage.AllowAutoApprove,AllowAttachment:stage.AllowAttachment,AutoApproveDay:stage.AutoApproveDay,AllowForms:stage.AllowForms,AllowAction:stage.AllowAction,Stage_Field:Stage_Field }
        })

    
  
        let data = {    
            processId : this.state.processId,
            ProcessDesc: this.state.processDesc,
            IsActive: this.state.isActive,
            ModuleNum: this.state.ModuleNum,
            SubMenuID:this.state.SubMenuID,
            MenuID:this.state.MenuID,
            CompanyId: this.props.loggedUserDetail.CompanyId,
            CreatedBy: this.props.loggedUserDetail.EmployeeName,
            CreatedDate: this.state.CreatedDate,
            Stage : stages
        }

        if(this.state.type ==='Edit'){
            data.processNum = this.state.processNum;
        }


        var dd = JSON.stringify(data);
        var datas = {Key : dd};

        let url = (this.state.type === 'Edit') ? '/master/api/UpdateDynamicData?model=processStage' : '/master/api/InsertDynamicData?model=processStage'

        let message = (this.state.type === 'Edit') ? 'Process Form Updated Successfully' : 'Process Form Added Successfully';

        axios.post(url, JSON.stringify(datas))
        .then(response =>{
            if(response.data.statusCode !== -1){                
                this.growl.show({severity: 'success', summary: null, detail: message});

                   setTimeout(()=> {
                        this.props.history.push('/process-list')
                    }, 2000)

                
                this.setState({loading : false});
            }else{
                this.growl.show({severity: 'error', summary: null, detail: response.data.message});
                this.setState({loading : false});
            }
        })
        .catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong.'});
            this.setState({loading : false});
        })    

    }


    render() {   

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

       
        let isEnabled = (this.state.ModuleNum !== '' );

        let stageContent ='';
        if(this.state.stages.length > 0){
            stageContent = this.state.stages.map((stage, index) => {
                return(
                <div className="p-col-12" key={index}>
                                        <div className="card card-w-title">
                                        <h1>Stage {index + 1} </h1>

                                        

                                        <Link style={{float: 'right',position: 'relative', top: '-4em'}} to="#"><Button className="p-button-danger" onClick={(e) => this.removeStage(e, index)} icon="pi pi-times"/></Link>

                                        <div className="p-grid">
                                        
                                        <div className="p-col-12 p-md-6" style={{marginTop:'1em',marginBottom:'1em'}}>
                                        <InputText className="p-col-12"  placeholder="Stage Description"  value={stage.Description} name={`Description`} onChange={(e) => this.updateDynamicStageFields(e, index)}/>                                           
                                        </div>

                                        <div className="p-col-12 p-md-6" style={{marginTop:'1em',marginBottom:'1em'}}>
                                        <InputText className="p-col-12" type="number"  placeholder="Stage Sequence"  value={stage.StageSequence} name={`StageSequence`} onChange={(e) => this.updateDynamicStageFields(e, index)}/>                                           
                                        </div>


                                        <div className="p-col-12 p-md-3" style={{marginTop:'1em',marginBottom:'1em',textAlign:'center'}}>
                                            <label htmlFor="cb1" className="autoApprovebtn">Allow Auto Approve</label>
                                            <InputSwitch name={`AllowAutoApprove`}  checked={stage.AllowAutoApprove} onChange={(e) => this.updateDynamicStageFields(e, index)}/>
                                        </div>

                                        <div className="p-col-12 p-md-3" style={{marginTop:'1em',marginBottom:'1em',textAlign:'center'}}>
                                            <label htmlFor="cb1" className="autoApprovebtn">Attachments</label>
                                            <InputSwitch name={`AllowAttachment`}  checked={stage.AllowAttachment} onChange={(e) => this.updateDynamicStageFields(e, index)}/>
                                        </div>

                                        <div className="p-col-12 p-md-3" style={{marginTop:'1em',marginBottom:'1em',textAlign:'center'}}>
                                            <label htmlFor="cb1" className="autoApprovebtn">Forms</label>
                                            <InputSwitch name={`AllowForms`}  checked={stage.AllowForms} onChange={(e) => this.updateDynamicStageFields(e, index)}/>
                                        </div>

                                        <div className="p-col-12 p-md-3" style={{marginTop:'1em',marginBottom:'1em',textAlign:'center'}}>
                                            <label htmlFor="cb1" className="autoApprovebtn">Allow Action</label>
                                            <InputSwitch name={`AllowAction`}  checked={stage.AllowAction} onChange={(e) => this.updateDynamicStageFields(e, index)}/>
                                        </div>

                                        <div className="p-col-12 p-md-12" style={{marginTop:'1em',marginBottom:'1em'}}>
                                        <InputText className="p-col-12" type="number"  placeholder="Auto approve if not approved with in given days"  value={stage.AutoApproveDay} name={`AutoApproveDay`} onChange={(e) => this.updateDynamicStageFields(e, index)}/>                                           
                                        </div>


                                        

                                        

                                             { stage.Stage_Field.length > 0 &&
                                            <>
                                                {stage.Stage_Field.map((field, btnIndex) => {
                                
                                                        return(
                                                            <React.Fragment key={btnIndex}>
                                                                <div className="p-col-12 p-md-3">
                                                                    <InputText className="p-col-12" placeholder="Field Description" value={field.FieldDescription} name={`FieldDescription`} onChange={(e) => this.updateDynamicFields(e, index, btnIndex)}/>
                                                                </div>
                                                                <div className="p-col-12 p-md-3">
                                                                    <Dropdown className="p-col-12" options={this.state.selectOption} placeholder="Select Field Type" value={field.FieldType} name={`FieldType`} onChange={(e) => this.updateDynamicFields(e, index, btnIndex)}/>
                                                                </div>

                                                                { (field.FieldType !== 9) &&
                                                                <> 
                                                                    <div className="p-col-12 p-md-3">
                                                                        <Dropdown className="p-col-12" options={this.state.dataSourceOption} 
                                                                        placeholder="Select Dropdown API" value={field.dropdownValue} name={`dropdownValue`} onChange={(e) => this.updateDynamicFields(e, index, btnIndex)}/>
                                                                    </div>
                                                                    <div className="p-col-12 p-md-3">
                                                                        <Dropdown className="p-col-12" options={this.state.parentControlOption} 
                                                                        placeholder="Select Parent Control" value={field.ParentFieldNum} name={`ParentFieldNum`} onChange={(e) => this.updateDynamicFields(e, index, btnIndex)}/>
                                                                    </div>

                                                                    <div className="p-col-12 p-md-3">
                                                                        <Dropdown className="p-col-12" options={this.state.fieldStatusOption} 
                                                                        placeholder="Select Field Status" value={field.FieldStatus} name={`FieldStatus`} onChange={(e) => this.updateDynamicFields(e, index, btnIndex)}/>
                                                                    </div>

                                                                    <div className="p-col-12 p-md-5">
                                                                        <MultiSelect className="p-col-12" options={FieldValidations} 
                                                                        placeholder="Select Form Validation" value={field.FieldValidation} name={`FieldValidation`} onChange={(e) => this.updateDynamicFields(e, index, btnIndex)}/>
                                                                    </div>

                                                                    <div className="p-col-12 p-md-3">
                                                                        <Dropdown className="p-col-12" options={this.state.ValidationAPI} 
                                                                        placeholder="Select Validation API" value={field.ValidationAPI} name={`ValidationAPI`} onChange={(e) => this.updateDynamicFields(e, index, btnIndex)}/>
                                                                    </div>
                                                                </>
                                                                }

                                                                <div className="p-col-12 p-md-1">
                                                                   
                                                                    {(btnIndex ===0) ? 
                                                                     <Button onClick={(e) => this.addFields(e, index, btnIndex)} title={`Add Fields`} icon="pi pi-plus" className="p-button-success"/>

                                                                    : null}

                                                                    {(btnIndex!==0) ? 
                                                                    <Button  onClick={(e) => this.removeFields(e, index, btnIndex)} title={`Remove Fields`} icon="pi pi-trash" className="p-button-danger"/>
                                                                    : null}
                                                                  

                                                                </div>
                                                                <div className="p-col-12 p-lg-12"></div>
                                                             </React.Fragment>
                                                        )
                                            
                                                })}
                                            </>
                                            }     
                                            


                                        </div>

                                        </div>
                                    </div> ) 
             })
        }


        let moduleLists = [];
        if(this.props.moduleLists){
            moduleLists = this.props.moduleLists;
        }

        let menuLists = [];
        if(this.props.menuLists && this.props.menuLists.length > 0){
    

            let subMenu = [];

            menuLists= this.props.menuLists.map((menu) => {

                if(menu.menuRights.length > 0){

                    subMenu = menu.menuRights.map((sub,index) => {
                        if(index === 0){
                            return {
                                menuId:sub.menuId
                            }
                        }else{
                            return false;
                        }
                    });

                }

                return { label: menu.mainmenu, value : subMenu[0].menuId }
            })

        }


        return (
            <div className="p-grid leaverequest">
                { this.props.loading && <div className="page-loader"></div>}
                { this.state.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Create Process Form</h1>
                  
                        <div className="p-grid mt1">

                        <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                <Button label="Create Stage" icon="pi pi-plus" style={{marginRight:'.25em',float:'right'}} onClick={this.createStage} />
                                </div>                                
                            </div>



                           <div className="p-col-12">
                               <label htmlFor="acSimple">Process Number</label>
                           </div>
                           <div className="p-col-6 ">
                           <InputText className="p-col-12 p-disabled" name="ProcessNum" value={this.state.processNum} readOnly/>
                           </div>	

                           <div className="p-col-12">
                               <label htmlFor="acSimple">Process Description <span className="requiredColor">*</span></label>
                           </div>
                           <div className="p-col-6 ">
                           <InputText className="p-col-12" name="processDesc" onChange={(e) => this.setState({processDesc:e.target.value})} value={this.state.processDesc} placeholder="Process Description"/>
                           </div>	

                           <div className="p-col-12">
                               <label htmlFor="acSimple">Module Name <span className="requiredColor">*</span></label>
                           </div>
                           <div className="p-col-6 ">
                                <Dropdown className="p-col-12"  name="ModuleNum" options={moduleLists} value={this.state.ModuleNum} onChange={e => this.setState({ModuleNum: e.target.value})} autoWidth={false} placeholder="Select Module" />
                           </div>


                           <div className="p-col-12">
                               <label htmlFor="acSimple">Select Menu <span className="requiredColor">*</span></label>
                           </div>
                           <div className="p-col-6 ">
                                <Dropdown className="p-col-12"  name="MenuID" options={menuLists} value={this.state.MenuID} onChange={e => this.setState({MenuID: e.target.value})} autoWidth={false} placeholder="Select Menu" />
                           </div>



                           { this.state.type === 'Edit' && 
                           <>
                           <div className="p-col-12">
                               <label htmlFor="acSimple">Status :</label>
                           </div>
                           <div className="p-col-6 ">
                                    <InputSwitch name={`isActive`}  checked={this.state.isActive} onChange={() => this.setState({isActive: !this.state.isActive})}/>
                           </div>
                           </>
                           }

                        </div>   

                        
                    </div>
                </div>

                
                {stageContent}


               
                <div  className="p-col-12">


                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.addProcessForm} reset={this.props.history.goBack}  to={"/process-list/"} />

                    {/* <Button disabled={!isEnabled} style={{float: 'right'}}  label="Save" icon="pi pi-save" onClick={this.addProcessForm}/>


                    <Button icon="pi pi-times" style={{float: 'right'}} onClick={this.props.history.goBack} label="Cancel" className="p-button-secondary  mr1" />

                    <Link to="/process-list"><Button style={{float: 'right'}} icon="pi pi-arrow-left" label="Back" className="p-button-secondary mr1" /></Link> */}

                </div>
                 
           

           
           
           
           
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        moduleLists : state.master.keywordValuesList,
        loading : state.master.loading,
        error : state.master.error,
        fetchData : state.master.fetchData,
        employeeID : state.auth.userObject.empID,
        menuLists : state.auth.menuLists,
    }
}
  

const mapDispatchToProps = dispatch => {
    return{
        getModuleLists : () => dispatch(actions.getKeywordValues('Module')),
        fetchProcessForm : (processId) => dispatch(actions.fetchProcessForm(processId,'process')),
        onMenuAccess    : (empID,type) => dispatch(actions.getMenuAccess(empID,type))
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(ProcessForm);